// src/components/Header.jsx
import React from 'react';
import {useState ,useContext} from "react";
import { BsBrightnessHighFill } from "react-icons/bs";
import { MdDarkMode } from "react-icons/md";
import userImage from "../images/new-user.jfif";
import { ThemeContext } from "../context/ThemeContext";

const Header = ({sidebarOpen , setSidebarOpen}) =>{
  const { theme, toggleTheme } = useContext(ThemeContext);  
  return(
    <nav className="topbar">
          <div className="logo">
            <button
              aria-label="sidebar-btn"
              className={`${!sidebarOpen ? "menu-button close" : "menu-button"}`}
              onClick={() => setSidebarOpen(!sidebarOpen)}
            >
              ☰
            </button>
            <span>synia</span>
          </div>
  
          <div className="topbar-right">
            <select className="language-select">
              <option value="en-usa">en-usa</option>
            </select>
            <span className="separator"></span>
            <div className="user-profile">
              <img alt='user-profile' src={userImage} width={100} height={100} />
              <select className="language-select">
                <option value="user-name">User Name</option>
              </select>
            </div>
            <span className="separator"></span>
            <button  aria-label="theme-btn" className="theme-toggle" onClick={toggleTheme}>
              {
                theme == 'light' ? <BsBrightnessHighFill /> : <MdDarkMode  style={{ color: 'white' }}/>
              }
            </button>
          </div>
        </nav>
  );
} 
export default Header;
